import {
  ClubProgrammeBatchSelection,
  ClubProgrammeBatchSelectAll,
  ClubProgrammeBatchAddPayload,
  ClubProgrammeBatchRemovePayload
} from './clubProgrammes.types';

export const toBool = (v: any) => {
  if (v === true || v === false) return v;
  if (typeof v === 'number') return v === 1;

  const s = String(v ?? '')
    .trim()
    .toLowerCase();

  if (s === 'true' || s === '1') return true;
  if (s === 'false' || s === '0') return false;

  return !!v;
};

export const uniqStrings = (arr: any): string[] => {
  const a = Array.isArray(arr) ? arr : [];
  const out: string[] = [];
  const seen = new Set<string>();

  for (const x of a) {
    const v = String(x ?? '').trim();
    if (!v) continue;
    if (seen.has(v)) continue;
    seen.add(v);
    out.push(v);
  }

  return out;
};

export const normalizeIdArray = (v: any): string[] => {
  if (Array.isArray(v)) return uniqStrings(v);

  if (typeof v === 'string') {
    const s = v.trim();
    if (!s) return [];

    try {
      const parsed = JSON.parse(s);
      if (Array.isArray(parsed)) return uniqStrings(parsed);
    } catch (e) {}

    return uniqStrings(s.split(',').map(x => x.trim()));
  }

  if (v && typeof v === 'object') {
    const obj = v as Record<string, any>;
    const vals = Object.keys(obj).map(k => obj[k]);
    return uniqStrings(vals);
  }

  return [];
};

export const normalizeWhere = (whereRaw: any) => {
  const w = whereRaw && typeof whereRaw === 'object' ? whereRaw : {};
  if (Object.keys(w).length > 0) return w;
  return { _id: { $exists: true } };
};

export const normalizeBatchSelection = (data: any): ClubProgrammeBatchSelection => {
  const selectAll = toBool(data?.selectAll);

  if (selectAll) {
    const where = data?.filter?.where ?? data?.where ?? data?.clubWhere ?? {};
    const excludeClubIds = normalizeIdArray(data?.excludeClubIds ?? data?.['excludeClubIds[]']);

    const payload: ClubProgrammeBatchSelectAll = {
      selectAll: true,
      filter: { where: normalizeWhere(where) }
    };

    if (excludeClubIds.length) payload.excludeClubIds = excludeClubIds;

    return payload;
  }

  const clubIds = normalizeIdArray(data?.clubIds ?? data?.['clubIds[]']);

  return {
    selectAll: false,
    clubIds
  };
};

export const normalizeBatchAddPayload = (data: any): ClubProgrammeBatchAddPayload => {
  const base = normalizeBatchSelection(data);
  const payload: ClubProgrammeBatchAddPayload = { ...(base as any) };

  if (typeof data?.isEnabled !== 'undefined') payload.isEnabled = toBool(data.isEnabled);
  if (typeof data?.fieldsOverride !== 'undefined') payload.fieldsOverride = data.fieldsOverride;

  if (typeof data?.allowPastStartDate !== 'undefined') {
    payload.allowPastStartDate = toBool(data.allowPastStartDate);
  }

  return payload;
};

export const normalizeBatchRemovePayload = (data: any): ClubProgrammeBatchRemovePayload => {
  return normalizeBatchSelection(data);
};
